import { render, staticRenderFns } from "./custom_music_manage.vue?vue&type=template&id=7b738e66&scoped=true"
import script from "./custom_music_manage.vue?vue&type=script&lang=js"
export * from "./custom_music_manage.vue?vue&type=script&lang=js"
import style0 from "./custom_music_manage.vue?vue&type=style&index=0&id=7b738e66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b738e66",
  null
  
)

export default component.exports